import { McpChatState } from '../constants/mcpchat.constants';

export class McpChatStoreState {
  constructor() {
    this.chatState = McpChatState.COLLAPSED;
    this.conversationId = null;
    this.isLoading = false;
    this.loadingProgressMessages = [];
    this.historyItems = [];
    this.isHistoryOpen = false;
    this.isHistoryLoading = false;
    this.isHistoryLoadingMore = false;
    this.hasMoreHistory = false;
    this.historyNextOffset = 0;
    this.historyRequestVersion = 0;
    this.error = null;
    this.requestVersion = 0;
    this.conversationVersion = 0;
    this.isHydrated = false;
    this.suggestionPrompts = [];
    this.isSuggestionPromptsLoaded = false;
  }
}
